module.exports = __webpack_public_path__ + "static/img/babylon.4ff6976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/babylon.jpg
// module id = 4Bz9
// module chunks = 1